export namespace AppConfig {
	export const viewableDocumentTypes: string[] = [
		"application/pdf",
		"image/jpeg",
		"image/png",
	];

	export const viewableDocumentExtensions: string[] = [
		"pdf",
		"jpg",
		"png",
	];

	export const environment = {
		//name: "dev"
		//name: "test"
		name: "prod"
	}

	export const precisionDecimalsMaximum = 5;
	export const precisionDecimalsRounded = 2;

	export const defaultPageSize = 10;	
	export const materialTableDefaultSortField = "material";
	export const containerListDefaultSortField = "name";
	export const batchListDefaultSortField = 'batch';
	export const customerListDefaultSortField = "name";
	export const documentListDefaultSortField = 'entitytype';
	export const expenseListDefaultSortField = 'name';
	export const materialInventoryListDefaultSortField = '-createdon';
	export const materialPriceListDefaultPageSize = 50;
	export const materialPriceListDefaultSortField = 'material';
	export const reportRegistrationListDefaultPageSize = 50;
	export const reportRegistrationListDefaultSortField = 'ordinal';
	export const deletedLoadfListDefaultSortField = '-deleteddate';
	export const deletedShipmentListDefaultSortField = '-deleteddate';
	export const shipmentListDefaultSortField = '-pickupdate';
	export const shippingMaterialsDefaultPageSize = 5;
	export const shipmentPacketListDefaultSortField = '-shipmentdate';
	export const transporterListDefaultSortField = 'name';
	export const vendorListDefaultSortField = "name";
	export const waitingShipmentTableDefaultSortField = 'bol';

	export const addSuccessToastMs = 2000;
	export const editSuccessToastMs = 5000;
	export const apiConnectionErrorMessage = 'We are having trouble contacting the server. Please try again later.';
	export const defaultErrorProviderMessage = "We encountered an error while processing your request. Please try again.";
	export const grossWeightMaterialMessage = "* Indicates a gross weight material. The container weight is included in the material weight.";

	// IndexedDB settings for local storage
	export const idbStore = "HwiOnlineLocalStore";
	export const idbCredentialsTable = "Credentials";
	export const idbUpdateClaimsTable = "UpdateClaims";
	export const idbUpdateClaimYieldDurationMs = 3 * 60 * 1000;

	// Application Hub settings
	export const appHubBroadcastChannelName = "hwi-application-hub";

	// Credential Manager settings
	export const credentialManagerExpirationPollMs = 60 * 1000; // Poll for access token expiration every 60 seconds
	export const credentialManagerRefreshAfterRemainingMs = 6 * 60 * 1000; // Refresh access token after 6 minutes remaining until expiration	
	export const credentialManagerMaxRetryAttempts = 5; // Auto-retry failed MSAL requests a maximum of 5 times
	export const credentialManagerRetryAttemptDelayMs = 5 * 1000; // Delay 5 seconds between retry attempts
}
